/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_4_QInputs */

const en_serve_faq_4_q = /** @type {(inputs: Serve_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I still get the phone preview?`)
};

const id_serve_faq_4_q = /** @type {(inputs: Serve_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetap bisa coba di HP?`)
};

/**
* | output |
* | --- |
* | "Do I still get the phone preview?" |
*
* @param {Serve_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_4_q = /** @type {((inputs?: Serve_Faq_4_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_4_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_4_q(inputs)
	return en_serve_faq_4_q(inputs)
});